<template>
    <div class="column-layout">
        <swb-query-sort-area class="mb10" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row" name="btn-block" v-if="showAddFlag">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="addInvoiceSubject">新增</button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="invoiceSubjectList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : selectInvoiceSubject!= null && selectInvoiceSubject.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="invoiceTypeName" label="发票类型名称" align="left"></el-table-column>
                <el-table-column prop="realComName" label="实体公司" width="170" align="center"></el-table-column>
                <el-table-column prop="realComCode" label="实体公司编码" width="100" align="center"></el-table-column>
                <el-table-column prop="invoiceTitle" label="发票抬头" width="170" align="center"></el-table-column>
                <el-table-column prop="taxPayerNo" label="纳税人识别号" width="180" align="left"></el-table-column>
                <el-table-column prop="contactName" label="联系人" width="120" align="left"></el-table-column>
                <el-table-column prop="contactTel" label="联系电话" width="120" align="left"></el-table-column>
                <el-table-column prop="contactEmail" label="联系电子邮箱" width="120" align="left"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtFinacApi from '../../api/merchtFinac'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbSaveMerchantInvoiceSubject from '../merchtFinac/SaveMerchantInvoiceSubject';
    Vue.regist(SwbSaveMerchantInvoiceSubject);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "发票类型名称",
            "code": "invoiceTypeName",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "发票抬头",
            "code": "invoiceTitle",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "纳税人识别号",
            "code": "taxPayerNo",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-invoice-subject-list-for-select',
        desc: '开票信息',
        props: {
            showAddFlag: {
                type: Boolean,
                default: false
            },
            buyerRealComId: {
                type: Number,
                default: null
            },
            buyerRealComCode: {
                type: String,
                default: null
            },
            invoiceType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                invoiceSubjectList: [],
                selectInvoiceSubject: null
            }
        },
        created: function () {
            this.queryConfig = searchConfigData || {};
            //
            this.getInvoiceSubject();
        },
        methods: {
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                //
                this.getInvoiceSubject();
            },
            getInvoiceSubject: function () {
                let self = this;
                let params = {};
                if(Utils.isNoB(self.buyerRealComId)) {
                    params.realComCodeFlag = true;
                    params.realComCode = self.buyerRealComCode;
                } else {
                    params.realComId = self.buyerRealComId;
                }
                if(!Utils.isNoB(this.invoiceType)) {
                    params.invoiceType = this.invoiceType;
                }
                params.disabled = false;
                merchtFinacApi.getMerchantInvoiceSubjectList(params, function (result) {
                    if(result.type === "info") {
                        self.invoiceSubjectList = Utils.merge([], result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择合同及商品
            handleCurrentChange: function (val) {
                this.selectInvoiceSubject = Utils.merge({}, val);
            },
            addInvoiceSubject: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "发票主体信息 - 添加",
                    width: 700,
                    height: 700,
                    template: '<swb-save-merchant-invoice-subject :buyerRealComId="buyerRealComId" :invoiceType="invoiceType" ref="swb_save_merchant_invoice_subject"></swb-save-merchant-invoice-subject>',
                    data: {
                        buyerRealComId: self.buyerRealComId || null,
                        invoiceType: self.invoiceType
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_save_merchant_invoice_subject.getDlgResult() || {};
                        if(result.type == 'info') {
                            let postData = result.data || {};
                            let msgBoxDlg = MsgBox.loading();
                            merchtFinacApi.saveMerchantInvoiceSubject(postData, function (result) {
                                msgBoxDlg.close();
                                if(result.type == 'info') {
                                    MsgBox.success('添加成功');
                                    //
                                    self.getInvoiceSubject();
                                    theDlg.close();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    }
                })
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let result = {};
                let selectInvoiceSubject = this.selectInvoiceSubject || {};
                if(!Utils.isNoB(selectInvoiceSubject) && selectInvoiceSubject.id > 0) {
                    result.type = "info";
                    result.data = selectInvoiceSubject;
                } else {
                    result.type = "warn";
                    result.message = "请选择发票信息！";
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/invoiceVoucher/InvoiceSubjectForSelect.vue